import React, { use, useState } from "react";
import Flooring from "../../../assets/img/flooring.svg";
import Garage from "../../../assets/img/Garage.svg";
import Simplified_re from "../../../assets/img/Simplified_re.svg";
import Trusted_Professionals from "../../../assets/img/Trusted_Professionals.svg";
import Smart_Technology from "../../../assets/img/Smart_Technology.svg";
import Save_Time from "../../../assets/img/Save_Time.svg";
import Hardscape from "../../../assets/img/Hardscape.svg";
import Finish from "../../../assets/img/Finish Carpentry.svg";
import Bathroom from "../../../assets/img/Bathroom Renovations.svg";
import Interior from "../../../assets/img/Interior Paint & Finish.svg";
import Artificial from "../../../assets/img/Artificial Grass.svg";
import Exterior from "../../../assets/img/Exterior Paint & Finish.svg";
import Doors from "../../../assets/img/Doors & Entryways.svg";
import Windows from "../../../assets/img/window.svg";
import Kitchen from "../../../assets/img/Kitchen.svg";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hitGetServicesCommonApi } from "../../../Redux/Common/GetServicesCommonSlice";
import Flooring1 from "../../../assets/img/flooring1.svg";
import next_icons from "../../../assets/img/next_icons.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { color } from "framer-motion";

const Services = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [serviceData, setServiceData] = React.useState(null);
  const [activeCard, setActiveCard] = useState(0);

  const params = new URLSearchParams(window.location.search);
  const serviceName = window.location.pathname.split("/").pop();

  const lastSegment = window.location.pathname.split("/").filter(Boolean).pop();
  //console.log("lastSegment", lastSegment);

  useEffect(() => {
    dispatch(hitGetServicesCommonApi(serviceName)).then((response) => {
      if (response.payload && response.payload.status === true) {
        setServiceData(response.payload.data);
      }
    });
  }, [dispatch]);

  const benefits = [
    {
      icon: <img src={Simplified_re} alt="Simplified Renovation Process" />,
      title: "Simplified Renovation Process",
      description:
        "Measure your space, upload project details, and get bids—all from the comfort of your home.",
    },
    {
      icon: <img src={Trusted_Professionals} alt="Trusted_Professionals " />,
      title: "Trusted Professionals at your Fingertips",
      description:
        "Connect with licensed, verified experts who are ready to make your project a reality.",
    },
    {
      icon: <img src={Save_Time} alt="Save_Time" />,
      title: "Save Time and Eliminate Hassle",
      description:
        "No in-home visits, no high-pressure sales tactics just fast, accurate bids.",
    },
    {
      icon: <img src={Smart_Technology} alt="Smart_Technology" />,
      title: "Smart Technology for Smarter Building",
      description:
        "Our advanced camera measurement tools ensure precise details, making the process seamless for everyone.",
    },
  ];

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="service_header">
        {lastSegment !== "all-services" && (
          <>
            <p className="subtitle pt-5">
              <span style={{ fontSize: "1.5rem", fontWeight: 600 }}>
                {serviceData?.name && (
                  <img src={serviceData.image} alt="flooring1" style={{ width: 30, height: 30, marginRight: 5, verticalAlign: "middle" }} />
                )}
                {serviceData?.name}
              </span>
            </p>
            <h2 className="main-title">{serviceData?.name}</h2>
            <p
              className="pb-0 pb-sm-2 pb-md-4 pb-md-5"
              style={{ fontSize: "18px" }}
            >
              {serviceData?.description}
            </p>
            {serviceData?.name === "Doors" ||
              serviceData?.name === "Windows" ? (
              <h2 className="subtitle">Coming Soon</h2>
            ) : null}
          </>
        )}
      </div>

      <div className="services-wrapper">
        <div className="custom_container">
          <div className="services-wrapper-section-top">
            {/* Header Section */}
            <div className="header-section">
              <p className="subtitle">
                <span>
                  WE'RE UNIQUELY COMMITTED TO YOUR RENOVATION'S SUCCESS
                </span>
              </p>
              <h2 className="main-title">
                The services offered on our platform are
              </h2>
            </div>

            {/* Services Grid */}
            <div className="services-grid">
              {serviceData &&
                serviceData.subServices.map((service) => (
                  <div key={service._id} className="service-card">
                    <div className={`icon-wrapper ${service.colorClass}`}>
                      <span className="service-icon">
                        <img
                          src={service.image}
                          alt={service.name}
                          style={{ width: "35px", height: "35px" }}
                        />
                      </span>
                    </div>
                    <h3 className="service-title">{service.name}</h3>
                    <p className="service-description">{service.description}</p>
                    {lastSegment !== "all-services" ?(

                      (serviceData.name === "Doors" ||
                        serviceData.name === "Windows") ? (
                       <a
                        onClick={() => {
                          handleViewDetails();
                          navigate("/select-role", {
                            state: { clickBy: "Client" },
                          });
                        }}
                        className="start-project-link"                    
                        style={{ cursor: "pointer" }}
                      >
                             Coming Soon
                        <span className="arrow">
                          <img src={next_icons} alt="next_icons" />
                        </span>
                      </a>
                      ) : <a
                        onClick={() => {
                          handleViewDetails();
                          navigate("/select-role", {
                            state: { clickBy: "Client" },
                          });
                        }}
                        className="start-project-link"
                        style={{ cursor: "pointer" }}
                      >
                        Start Your Project{" "}
                        <span className="arrow">
                          <img src={next_icons} alt="next_icons" />
                        </span>
                      </a>
                    ) : (
                    <a
                      href={
                        service.name === "Floor Coverings"
                          ? "/service/floor-coverings"
                          : service.name === "Artificial Grass"
                            ? "/service/artificial-grass"
                            : service.name === "Garage Door"
                              ? "/service/garage-door"
                              : service.name === "Bath"
                                ? "/service/bath"
                                : service.name === "Kitchen"
                                  ? "/service/kitchen"
                                  : service.name === "Interior Paint"
                                    ? "/service/interior-paint"
                                    : service.name === "Doors & Windows"
                                      ? "/service/doors-windows"
                                      : "/client/login"
                      }
                      onClick={() => handleViewDetails()}
                      className= "start-project-link"                    
                      style={{ cursor: "pointer" }}
                    >
                     Learn More

                      <span className="arrow">
                        <img src={next_icons} alt="next_icons" />
                      </span>
                    </a>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>

        {/* Why Choose Section */}
        <div className="why-choose-section">
          <div className="custom_container">
            <div className="section-header">
              <h2 className="section-title">Why Choose SimpleRenovate</h2>
              <p className="section-subtitle">
                We're committed to making your renovation experience smooth,
                reliable, and
                <br /> stress-free.
              </p>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="benefit-card"
                  onClick={() => setActiveCard(index)}
                  style={{
                    border:
                      activeCard === index
                        ? "1px solid #9a1d1c"
                        : "1px solid transparent",
                  }}
                >
                  <div className="benefit-icon-wrapper">
                    <span className="benefit-icon">{benefit.icon}</span>
                  </div>
                  <h3
                    className="benefit-title"
                    style={{
                      // color: activeCard === index ? "#cc4645" : "#000",
                      background:
                        activeCard === index
                          ? "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)"
                          : "none",
                      webkitBackgroundClip:
                        activeCard === index ? "text" : "initial",
                      webkitTextFillColor:
                        activeCard === index ? "transparent" : "initial",
                    }}
                  >
                    {benefit.title}
                  </h3>
                  <p className="benefit-description">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
          <section className="cta-sections">
            <div className="cta-container">
              <h2 className="cta-title">
                Ready to Start Your Renovation Project?
              </h2>
              <p className="cta-subtitle">
                Get matched with trusted professionals and receive competitive
                quotes today
              </p>
              <div className="cta_btn_center">
                <button
                  className="cta-button"
                  onClick={() => {
                    handleViewDetails();
                    navigate("/select-role", { state: { clickBy: "Client" } });
                  }}
                >
                  Get Started <ArrowForwardIcon className="ms-2" />
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Services;
